import { render, staticRenderFns } from "./PanelToolbar.vue?vue&type=template&id=964f4a80&scoped=true"
import script from "./PanelToolbar.vue?vue&type=script&lang=js"
export * from "./PanelToolbar.vue?vue&type=script&lang=js"
import style0 from "./PanelToolbar.vue?vue&type=style&index=0&id=964f4a80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964f4a80",
  null
  
)

export default component.exports